import React from 'react';
import { Loader2, StopCircle, Download } from 'lucide-react';
import { Button } from '../ui/button';
import { Progress } from '../ui/progress';

interface ActionButtonsProps {
  isProcessing: boolean;
  processingProgress: number;
  pendingCount: number;
  hasResults: boolean;
  onProcess: () => void;
  onCancel: () => void;
  onExport: () => void;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  isProcessing,
  processingProgress,
  pendingCount,
  hasResults,
  onProcess,
  onCancel,
  onExport,
}) => {
  return (
    <div className="border-t dark:border-gray-800 bg-white dark:bg-gray-900 p-4 space-y-3">
      {/* Progress bar when processing */}
      {isProcessing && (
        <div className="space-y-1">
          <div className="flex justify-between text-xs text-muted-foreground">
            <span>Processing...</span>
            <span>{Math.round(processingProgress)}%</span>
          </div>
          <Progress value={processingProgress} className="h-1.5" />
        </div>
      )}

      {/* Action buttons */}
      <div className="flex gap-2">
        <Button
          className="flex-1 transition-all duration-200"
          onClick={onProcess}
          disabled={isProcessing || pendingCount === 0}
        >
          {isProcessing ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Processing
            </>
          ) : (
            <>Process{pendingCount > 0 ? ` (${pendingCount})` : ''}</>
          )}
        </Button>

        {isProcessing && (
          <Button
            variant="destructive"
            size="icon"
            onClick={onCancel}
            title="Cancel processing"
          >
            <StopCircle className="w-4 h-4" />
          </Button>
        )}

        {!isProcessing && hasResults && (
          <Button
            variant="outline"
            size="icon"
            onClick={onExport}
            title="Export results"
          >
            <Download className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  );
};
